/* LoginSectionRenderer.js */

"use strict";
// const WarningBarGLComponent = require("@gluenetworks/gl_warning_bar");
let LoginForm = require("./loginform/LoginFormComponent");
let ContentBar = require("./contentbar/ContentBarComponent");

class LoginSectionMgrRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("login-section-gl");
        this._loginForm = new LoginForm();
        // this._warningBar = new WarningBarGLComponent();

        this._rootElem.classList.add("login-variant-b");
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        this._unregisterListeners();
        let promArr = [
            // this._warningBar.shutdown(),
            this._loginForm.shutdown(),
            this._contentBar && this._contentBar.shutdown(),
        ];

        return Promise.all(promArr)
            .then(() => {
                // this._warningBar = undefined;
                this._loginForm = undefined;
                this._contentBar = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            })
            .catch((err) => {
                console.log("Error shutting down LoginSectionRenderer: ", err);
            });
    }

    _registerListeners() {
        this._model.on("Shutdown", (this._shutdown = this._shutdown.bind(this)));
        this._model.on("error", (this._onError = this._onError.bind(this)));
        this._model.on("info", (this._onInfo = this._onInfo.bind(this)));
        this._model.on("challenge", (this._onChallenge = this._onChallenge.bind(this)));
        this._model.on(
            "user.request.success",
            (this._onHelpRequestSuccess = this._onHelpRequestSuccess.bind(this))
        );
        this._model.on(
            "password.request.success",
            (this._onHelpRequestSuccess = this._onHelpRequestSuccess.bind(this))
        );
        this._loginForm.on("username.request", (this._userRequest = this._userRequest.bind(this)));
        this._loginForm.on(
            "password.request",
            (this._passwordRequest = this._passwordRequest.bind(this))
        );
        this._loginForm.on("login.request", (this._loginRequest = this._loginRequest.bind(this)));
        this._loginForm.renderer.rootElement.addEventListener(
            "focus",
            (this._onLoginFormFocus = this._onLoginFormFocus.bind(this)),
            true
        );
    }

    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._shutdown);
        this._model.removeListener("error", this._onError);
        this._model.removeListener("info", this._onInfo);
        this._model.removeListener("challenge", this._onChallenge);
        this._model.removeListener("user.request.success", this._onHelpRequestSuccess);
        this._model.removeListener("password.request.success", this._onHelpRequestSuccess);
        this._loginForm.removeListener("username.request", this._userRequest);
        this._loginForm.removeListener("password.request", this._passwordRequest);
        this._loginForm.removeListener("login.request", this._loginRequest);
        this._loginForm.renderer.rootElement.removeEventListener("focus", this._onLoginFormFocus);
    }

    _onFormContainerClick() {
        if (this._contentBar.veilShown) {
            this._contentBar.veilShown = false;
        }
    }

    _userRequest(emailAddress) {
        this._model.userRequest(emailAddress);
    }

    _passwordRequest(emailAddress) {
        this._model.passwordRequest(emailAddress);
    }

    _loginRequest(data) {
        this._model.loginRequest(data);
    }

    _onError(err) {
        this._loginForm.errorMsg = err;
    }

    _onInfo(info, isChallengeRequest) {
        if (isChallengeRequest) {
            this._loginForm._changeFormToChallenge();
        }
        this._loginForm.infoMsg = info;
    }

    _onHelpRequestSuccess(/*response*/) {
        this._loginForm.hideHelp();
    }

    _onLoginFormFocus(/*event*/) {
        // if (this._warningBar.shown) {
        //     this._warningBar.hide(3000);
        // }
    }
    _onChallenge() {
        this._loginForm.clearPassword();
    }

    _renderWallpaper() {
        const picture = document.createElement("picture");
        picture.classList.add("login-wallpaper-picture");

        const s1 = document.createElement("source");
        s1.setAttribute("srcset", "images/gw-login-wallpaper-2x.avif");
        s1.setAttribute("type", "image/avif");
        s1.setAttribute("media", "(-webkit-min-device-pixel-ratio: 2)");

        const s2 = document.createElement("source");
        s2.setAttribute("srcset", "images/gw-login-wallpaper.avif");
        s2.setAttribute("type", "image/avif");

        const s3 = document.createElement("source");
        s3.setAttribute("srcset", "images/gw-login-wallpaper-2x.webp");
        s3.setAttribute("type", "image/webp");
        s3.setAttribute("media", "(-webkit-min-device-pixel-ratio: 2)");

        const s4 = document.createElement("source");
        s4.setAttribute("srcset", "images/gw-login-wallpaper.webp");
        s4.setAttribute("type", "image/webp");

        const img = document.createElement("img");
        img.setAttribute("src", "images/gw-login-wallpaper.jpg");
        img.classList.add("login-wallpaper");
        img.setAttribute("alt", "");
        img.setAttribute("aria-hidden", "true");

        picture.append(s1, s2, s3, s4, img);
        this._rootElem.appendChild(picture);
    }

    _renderLoginForm() {
        this._loginFormContainer = document.createElement("login-form-container");
        this._loginFormContainer.addEventListener(
            "click",
            (this._onFormContainerClick = this._onFormContainerClick.bind(this))
        );
        this._loginForm.renderer.rootElement.setAttribute("tabindex", "-1");
        this._loginFormContainer.appendChild(this._loginForm.renderer.rootElement);
        // this._rootElem.appendChild(this._warningBar.renderer.rootElement);
        this._rootElem.appendChild(this._loginFormContainer);
        return this._loginForm.renderer.render();
    }

    _renderContentBar(contentItems) {
        this._contentBar = new ContentBar({
            items: contentItems,
            veilContainer: this._loginFormContainer,
        });
        this._rootElem.appendChild(this._contentBar.renderer.rootElement);
        return this._contentBar.renderer.render();
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this._model.checkLoginOptions().then((allowLocalLogin) => {
            if (!allowLocalLogin) {
                // Never resolve: keeps the section router's loading mask up until navigation away.
                location.href = `${window.origin}/session/directToLogin`;
                return new Promise(() => {});
            }
            this._registerListeners();
            return this._renderLoginForm()
                .then(() => {
                    return this._model.getContent();
                })
                .then((content) => {
                    return this._renderContentBar(content);
                })
                .then(() => {
                    this._renderWallpaper();
                });
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = LoginSectionMgrRenderer;
